const translations = {
  "en": {
    "Add manually": "Add manually",
    "Can't find your account?": "Can't find your account?",
    "Close": "Close",
    "Connect others": "Connect others",
    "Everyday spending is where the quiet leaks live. One account is enough to start.": "Everyday spending is where the quiet leaks live. One account is enough to start.",
    "Go back": "Go back",
    "Over 12,000 institutions supported": "Over 12,000 institutions supported",
    "Popular Institutions": "Popular Institutions",
    "Start with where you spend from": "Start with where you spend from"
  },
  "zh-tw": {
    "Add manually": "手動新增",
    "Can't find your account?": "找不到你的帳號？",
    "Close": "關閉",
    "Connect others": "連結其他機構",
    "Everyday spending is where the quiet leaks live. One account is enough to start.": "日常支出正是細微流失的所在。僅需一個帳戶即可開始。",
    "Go back": "返回",
    "Over 12,000 institutions supported": "支援超過 12,000 家機構",
    "Popular Institutions": "知名機構",
    "Start with where you spend from": "從支出來源開始"
  }
};

export default translations;
